module.exports = __webpack_public_path__ + "static/media/02_van.dd01f392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/street/02_van.png
// module id = 454
// module chunks = 0